import React, { useState } from 'react';
import axios from 'axios';
import Cookies from "universal-cookie";
import { useNavigate } from "react-router-dom";

const BaseUrl = process.env.REACT_APP_BASE_URL;

const cookies = new Cookies();

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  React.useEffect(() => {
    const token = cookies.get("token");
    if (token) {
      navigate("/dashboard");
    }
  }, [navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setLoading(true);
    try {
      const res = await axios.post(`${BaseUrl}vendor/login`, { email, password });
      const token = res?.data?.data?.token;
      if (!token) throw new Error('Token not found in response');

      cookies.set('token', token, {
        path: '/',
        sameSite: 'lax',
        secure: window.location.protocol === 'https:',
      });

      navigate('/dashboard');
    } catch (err) {
      setError(err?.response?.data?.message || err?.message || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-vh-100 d-flex flex-column" style={{
      background: 'linear-gradient(135deg, #eca0a0ff 0%, #fff7ed 40%, #ffffff 100%)'
    }}>
      <style>
        {`
          .glass {
            backdrop-filter: blur(12px);
            background: rgba(255, 255, 255, 0.7);
            box-shadow: 0 10px 20px rgba(0,0,0,0.07);
            border: 1px solid rgba(255,255,255,0.3);
          }
          .login-shadow {
            box-shadow: 0 8px 32px 0 rgba(31, 38, 135, 0.15);
          }
        `}
      </style>

      <div className="container d-flex flex-grow-1 align-items-center justify-content-center">
        <div className="glass login-shadow rounded-4 p-4 p-md-5 w-100" style={{ maxWidth: 480 }}>
          <h2 className="fs-2 fw-bold text-dark text-center mb-4">
            Welcome Back
          </h2>

          {error && (
            <div className="alert alert-danger" role="alert">
              {error}
            </div>
          )}

          <form onSubmit={handleSubmit} className="d-grid gap-3">
            <div>
              <label htmlFor="email" className="form-label fw-semibold text-secondary mb-1">
                Email
              </label>
              <input
                id="email"
                type="email"
                className="form-control form-control-lg"
                placeholder="you@example.com"
                required
                onChange={e => setEmail(e.target.value)}
              />
            </div>

            <div>
              <label htmlFor="password" className="form-label fw-semibold text-secondary mb-1">
                Password
              </label>
              <input
                id="password"
                type="password"
                className="form-control form-control-lg"
                placeholder="••••••••"
                required
                onChange={e => setPassword(e.target.value)}
              />
            </div>

            <button
              type="submit"
              className="btn btn-common btn-lg fw-semibold shadow-sm"
              disabled={loading}
            >
              {loading ? 'Logging in…' : 'Login'}
            </button>
          </form>

          <div className="text-center text-muted small mt-4">
            Don&apos;t have an account?{' '}
            <a href="/register" className="link-warning fw-semibold text-decoration-none">
              Register
            </a>
          </div>

          <div className="text-center text-muted small mt-2">
            Forgot your password?{' '}
            <a href="/forget-password" className="link-warning fw-semibold text-decoration-none">
              Reset Password
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
